import Timeout from '@/types/timeout.d'

export type CancelFunc = () => void

export default function periodic(period: number, cb: () => void | Promise<void>): CancelFunc {
  let timeout: Timeout
  let canceled = false
  const loop = () => {
    clearTimeout(timeout)
    let callbackPromise = cb()
    if (!(callbackPromise && callbackPromise.then)) {
      callbackPromise = Promise.resolve()
    }
    // eslint-disable-next-line no-console
    callbackPromise.catch(console.error).finally(() => {
      if (!canceled) {
        timeout = setTimeout(loop, period)
      }
    })
  }
  loop()
  return () => {
    canceled = true
    clearTimeout(timeout)
  }
}
